window.copyLink = () => {
    return {
        copied: false,
        copyToClipboard() {
            navigator.clipboard.writeText(this.$el.getAttribute("href")).then(
                () => {
                    this.copied = true;
                    setTimeout(() => (this.copied = false), 2000);
                },
                () => {
                    /* clipboard write failed */
                }
            );
        },
    };
};
